export enum Operation {
  added = 'added',
  modified = 'modified',
  removed = 'removed'
}
